import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../../../Components/common/utils";
import moment from "moment";

const Our_Blog = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/blog/recent";
      const result = await fetchData(url);
      if (result) {
        setData(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);
  const skeleton = () => (
    <div className="d-flex gap-3">
      <div className="skeleton skeleton-img flex-shrink-0"></div>
      <div className="w-100">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-text"></div>
        <div className="skeleton skeleton-text"></div>
      </div>
    </div>
  );

  return (
    <>
      <section className="blog-section mt-5 mb-5 py-5">
        <div className="container">
          <h1 className="text-center mb-5">Our Blog</h1>
          <div className={`our-blog-wrapper ${loading ? "gap-3" : ""}`}>
            {!loading &&
              data?.map((details) => {
                return (
                  <div className="blog-card mt-2" key={details.id}>
                    <div className="img-wrapper">
                      <img
                        src={details.media[0].original_url}
                        alt={details.title}
                      />
                    </div>
                    <div>
                      <Link to={`/blogs/${details.slug}`} className="blog-title link">
                        {details.title}
                      </Link>
                      <div className="blog-date">
                        {moment(details.created_at).format("MMMM DD, YYYY")}
                      </div>
                      <p className="blog-description truncate-text">
                        {details.short_description}
                      </p>
                      <Link className="link" to={`/blogs/${details.slug}`}>
                        Read More
                      </Link>
                    </div>
                  </div>
                );
              })}
            {loading && (
              <>
                {skeleton()}
                {skeleton()}
                {skeleton()}
                {skeleton()}
              </>
            )}
          </div>
          {data.length >= 6 && (
          <div className="row">
            <div className="mt-4 text-center">
              <Link to="/blogs">
                <button className="custom-button">View All</button>
              </Link>
            </div>
          </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Our_Blog;
